module.exports = {
    appName: '米悅小說',
    index: '首頁',
    man: '男頻',
    woman: "精選",
    womanlabel: "精選",
    end: "完結",
    rank: "人氣榜",
    login: "登錄",
    reg: '注冊',
    bookMsg: '我的書架',
    addShelf: '加入書架',
    onShelf: '已在書架',
    searchMsg: '搜索',
    fb: '米悅小說FACEBOOK粉絲頁',
    focus: '關注',
    kefu: '客服電郵：',
    noresult: "暫無小說上架~",
    shelf: "書架",
    searchTip: "請輸入書名或關鍵詞",
    updateAt: "更新於",
    more: "更多>",
    account: "賬號",
    memAccount: "會員賬號",
    balance: "餘額",
    balancetip: "本章是VIP章節，訂閱後即可閱讀",
    coin: "金幣",
    payType: "儲值方式",
    payAmount: "儲值金額",
    resultCoin: "獲得金幣",
    giftCoin: "加贈",
    dollar: "美元",
    mlpay: "馬來西亞儲值",
    price: "章節價格",
    charge: "在線儲值",
    charge2: "充值",
    paypalpay: "PayPal支付",
    pftpay: "派付通支付",
    discount: "折",
    nomoredata: "沒有更多數據了。。。。",
    read: "立即閱讀",
    chapters: "查看目錄",
    serialize: "連載至",
    chapter: "章",
    cmtList: "書評區",
    cmt: "評論",
    clickMore: "點擊查看更多",
    guessLike: "猜你喜歡",
    loading: "拼命加載中。。。",
    free: "免費",
    total: "共",
    confirm: "確定",
    chooseSex:"請選擇性別",
    chooseLang:"請選擇語言",
    "第": "第",
    page: "頁",
    nextPage: "下一頁",
    changePwd: "修改密碼",
    oldPwd: "原密碼",
    newPwd: "新密碼",
    confirmPwd: "確認密碼",
    inputPwd: "請輸入密碼",
    inputNewPwd: "請輸入新密碼",
    inputOldPwd: "請輸入舊密碼",
    inputPwd2: "請再次輸入密碼",
    pwdNotMatch: "兩次輸入密碼不匹配",
    changePwdSuccess: "密碼修改成功",
    inputCmt: "請輸入您的評論",
    feedback: "意見反饋",
    inputFeedback: "請輸入您的寶貴意見",
    feedbackSuccess: "您的意見已提交，我們將盡快回複您",
    lastRead: "上次閱讀",
    latestRead: "最近閱讀",
    click: "點擊",
    fav: "收藏",
    then: "”然後選擇“",
    readNextTime: "方便下次閱讀喔",
    loginPage: "米悅小說賬號登錄",
    regPage: "米悅小說賬號注冊",
    memPwd: "會員密碼",
    memLogin: "會員登錄",
    memReg: "注冊賬號",
    inputAccount: "電子郵箱/手機號碼/昵稱",
    myCoin: "我的書幣",
    langSetting: "語言設置",
    download: "下載米悅小說APP",
    my: "個人中心",
    delShelf: "刪除書架",
    home: "返回首頁",
    cancle: "取消",
    clickDownload: "一鍵安裝米悅小說官方小說APP",
    menu: "菜單",
    preChapter: "上一章",
    nextChapter: "下一章",
    addShelfTip: "是否加入書架？方便下次閱讀",
    gender: "會員性別",
    memPwd: "會員密碼",
    male: "男",
    female: "女",
    regNow: "立即注冊",
    searchHistory: "曆史搜索",
    submit: "提交",
    detail: "書籍詳情",
    logout: "退出登錄",
    morePay: "更多儲值",
    hotsearch: "熱門搜索",
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/zh-tw.js
// module id = gbc4
// module chunks = 1